import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Prescriber } from '../../../core/models/prescriber.model';

import { ProviderNameWithNpiPipe } from '../../../shared/pipes/provider-name-with-npi.pipe';
import { SpecialtyBadgesComponent } from '../../../shared/components/specialty-badges/specialty-badges.component';

@Component({
    selector: 'app-prescriber-list',
    templateUrl: './prescriber-list.component.html',
    styleUrls: ['./prescriber-list.component.scss'],
    imports: [ProviderNameWithNpiPipe, SpecialtyBadgesComponent]
})
export class PrescriberListComponent {
  @Input() prescribers: Prescriber[];

  @Output() public prescriberSelect = new EventEmitter<Prescriber>();

  constructor() {}


  onPrescriberClick(prescriber: Prescriber) {
    this.prescriberSelect.emit(prescriber);
  }
}
